import NotificationList from '../../modules/NotificationList/NotificationList';
import s from './NotificationsScreen.module.css';
import {IGetNotificationsHistory, INotification} from "../../types";
import {ReactComponent as NotificationIcon} from '../../assets/icons/notification.svg';
import {useEffect, useState, useCallback, useRef} from "react";
import {appAxiosInstance} from "../../api";

export function NotificationsScreen() {
    const [isOpen, setIsOpen] = useState(false);
    const [countNotifications, setCountNotifications] = useState(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [notifications, setNotifications] = useState<INotification[]>([]);

    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    const getNotificationHistory = useCallback(async (showLoader = false) => {
        const params = {
            deviceGuid: localStorage.getItem("deviceGuid"),
        }

        try {
            if (showLoader) {
                setIsLoading(true);
            }

            const NotificationHistoryResponse = await appAxiosInstance.get<IGetNotificationsHistory>(
                'mobile/getNotificationsHistory',
                { params }
            );

            setNotifications(NotificationHistoryResponse.data.items);

            const unreadCount = NotificationHistoryResponse.data.items.filter(item => !item.isRead).length;
            setCountNotifications(unreadCount);

        } catch (error) {
            if (showLoader) {
                // toast.error(`Ошибка при получении списка уведомлений`);
            }
            setNotifications([]);
            setCountNotifications(0);
        } finally {
            if (showLoader) {
                setIsLoading(false);
            }
        }
    }, []);

    useEffect(() => {
        getNotificationHistory(true);
    }, [getNotificationHistory]);

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            getNotificationHistory(false);
        }, 5 * 60 * 1000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [getNotificationHistory]);

    useEffect(() => {
        if (isOpen) {
            getNotificationHistory(false);
        }
    }, [isOpen, getNotificationHistory]);

    const handleNotificationRead = async () => {
        await getNotificationHistory(true);
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={s.container}>
            <button
                className={s.button}
                onClick={toggleDropdown}
            >
                <NotificationIcon className={s.icon}/>
                <span className={s.badge}>{countNotifications}</span>
            </button>

            {isOpen && (
                <div className={s.dropdown}>
                    <NotificationList
                        isLoading={isLoading}
                        notifications={notifications}
                        onNotificationRead={handleNotificationRead}
                    />
                </div>
            )}
        </div>
    );
}